import React, { useEffect, useContext } from "react"
import { clBasic, Scrudo } from "./general";
import { AppContext } from "./index";
import ActividadesCosto from "./ActividadesCosto"
import EVdetalle from "./EVdetalle"

export default function Costos() {
    let { firebase } = useContext(AppContext);

    useEffect(() => {
        document.getElementById("htmlTituloPagS").innerHTML = "(Costos)";
    }, []);


    return (
        <div style={Scostos}>
            <div style={{ ...Scrudo, width: "54%" }}>
                <ActividadesCosto proyecto={firebase.proyectoActivo.proyecto.id} />
            </div>

            <div style={Sevp}>
                <EVdetalle proyecto={firebase.proyectoActivo.proyecto.id} />
            </div>
        </div>
    )
}

const Scostos = {
    height: "95%",
    width: "96%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-evenly",
    margin: "15px",
}

const Sevp = {
    width: "45%",
    height: "100%",
    color: clBasic,
}

